export default "__VITE_ASSET__56UkUgBp__"